import React from 'react';
import { Dropdown, Grid, Input, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

import Button from '../../../components/Button';
import EstateUnitFilter from '../../../components/EstateUnitFilter';
import { FieldLabel } from '../../../styles';

import { BondInsuranceInvoiceFiltersState } from '../types';

type DropdownOption = {
  key: string | number;
  value: string;
  text: string;
};

type Props = {
  isBackOffice: boolean;
  isEstateUser: boolean;
  estateOptions: DropdownOption[];
  insurerOptions: DropdownOption[];
  accountManagerOptions: DropdownOption[];
  filters: BondInsuranceInvoiceFiltersState;
  setFilters: React.Dispatch<React.SetStateAction<BondInsuranceInvoiceFiltersState>>;
  statusOptions: DropdownOption[];
  onSearch: () => void;
  onClear: () => void;
  isLoading: boolean;
};

const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;

  @media (max-width: 991px) {
    justify-content: flex-start;
  }

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const BondInsuranceInvoicesFiltersBar: React.FC<Props> = ({
  isBackOffice,
  isEstateUser,
  estateOptions,
  insurerOptions,
  accountManagerOptions,
  filters,
  setFilters,
  statusOptions,
  onSearch,
  onClear,
  isLoading
}) => {
  return (
    <Segment>
      <Grid stackable>
        <Grid.Row>
          {isBackOffice && (
            <Grid.Column computer={3} tablet={8} mobile={16}>
              <FieldLabel>Imobiliária</FieldLabel>
              <Dropdown
                fluid
                search
                clearable
                selection
                placeholder="Selecionar..."
                value={filters.estateId}
                options={estateOptions}
                onChange={(_, { value }) =>
                  setFilters(prev => ({
                    ...prev,
                    estateId: (value as string) || '',
                    estateUnitId: ''
                  }))
                }
                disabled={estateOptions.length === 1}
              />
            </Grid.Column>
          )}

          <EstateUnitFilter
            columnWidth={3}
            estateId={filters.estateId}
            value={filters.estateUnitId}
            onChange={value => setFilters(prev => ({ ...prev, estateUnitId: value }))}
          />

          <Grid.Column computer={3} tablet={8} mobile={16}>
            <FieldLabel>Seguradora</FieldLabel>
            <Dropdown
              fluid
              search
              clearable
              selection
              placeholder="Selecionar..."
              value={filters.insurerId}
              options={insurerOptions}
              onChange={(_, { value }) =>
                setFilters(prev => ({ ...prev, insurerId: (value as string) || '' }))
              }
              disabled={insurerOptions.length === 1}
            />
          </Grid.Column>

          {!isEstateUser && (
            <Grid.Column computer={3} tablet={8} mobile={16}>
              <FieldLabel>Gestor de contas</FieldLabel>
              <Dropdown
                fluid
                search
                clearable
                selection
                placeholder="Selecionar..."
                value={filters.accountManager}
                options={accountManagerOptions}
                onChange={(_, { value }) =>
                  setFilters(prev => ({
                    ...prev,
                    accountManager: (value as string) || ''
                  }))
                }
                disabled={accountManagerOptions.length === 1}
              />
            </Grid.Column>
          )}

          <Grid.Column computer={3} tablet={8} mobile={16}>
            <FieldLabel>Status</FieldLabel>
            <Dropdown
              fluid
              search
              clearable
              selection
              placeholder="Selecionar..."
              value={filters.status}
              options={statusOptions}
              onChange={(_, { value }) =>
                setFilters(prev => ({ ...prev, status: (value as string) || '' }))
              }
            />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column computer={3} tablet={8} mobile={16}>
            <FieldLabel>Data Inicial</FieldLabel>
            <Input
              fluid
              type="date"
              value={filters.start}
              onChange={(_, { value }) => setFilters(prev => ({ ...prev, start: value }))}
            />
          </Grid.Column>

          <Grid.Column computer={3} tablet={8} mobile={16}>
            <FieldLabel>Data Final</FieldLabel>
            <Input
              fluid
              type="date"
              value={filters.end}
              onChange={(_, { value }) => setFilters(prev => ({ ...prev, end: value }))}
            />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column computer={16} tablet={16} mobile={16}>
            <ActionsWrapper>
              <Button type="button" text="Pesquisar" onClick={onSearch} loading={isLoading} disabled={isLoading} />
              <Button light type="button" text="Limpar" onClick={onClear} disabled={isLoading} />
            </ActionsWrapper>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default BondInsuranceInvoicesFiltersBar;
